import { createContext, useContext } from "react"
import { FirestoreError } from "firebase/firestore"
import { Dayjs } from "dayjs"

export type ObservationDocument<Type extends string = string, T = Dayjs> = {
    id: string
    timestamp: T
    type: Type
} & (Type extends "feeding" ?
    {
        totalCount: number
        items: { species: string; count: number }[]
    }
    : Type extends "upload" ?
    {
        status: string,
        message: string,
        chunkSize: number,
        files: string[]
    }
    : {})

export type ObservationsContextProps = {
    data: ObservationDocument[]
    latest?: ObservationDocument
    loading: boolean
    error?: FirestoreError
}

export const ObservationsContext = createContext<ObservationsContextProps>({
    data: [],
    loading: true,
    error: undefined,
})

export const useObservations = () => useContext(ObservationsContext)

export * from "./ObservationsProvider"
